import { Stack } from 'expo-router'

type ExpoStackProps = React.ComponentProps<typeof Stack>

export const UpdatesLayout = ({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) => (
  <Stack {...ExpoStackProps}></Stack>
)
